
import "./ProfilePage.css";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePasswordSchema } from "./PasswordValidation";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { Formik, Form, Field } from "formik";
import { logoutUser } from "features/auth/authSlice";

import Navbar from "components/Navbar/Navbar";
import Loader from "utilities/reusableComponent/Loader/Loader";
import Swal from "sweetalert2";
import HidePassword from "assets/images/eye-password-hide.png";
import ShowPassword from "assets/images/eye-password-show.png";

function ChangePassword() {

    // get user token from global state
    const { userInfo } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Profile form initial values
    const initialValues = {
        old_password: "",
        new_password: "",
        confirm_new_pasword: ""
    }
    
    // Handling on Submit register form
    const onHandleChangePassword = async (values) => {
        setLoading(true);
        const changePasswordPayloads = {
            "user_uid": userInfo.uid,
            "current_password": values.old_password,
            "new_password": values.new_password
        };
    
        const res = await apiRequest({
          requestType: requestType.changePassword,
          payload: {
            data: changePasswordPayloads
          }
        });
    
        if (res?.data?.status === 0) {
            const swalFailedMessage = Swal.mixin({
                customClass: {
                  popup: 'swal-change-password-popup',
                  confirmButton: "swal-change-password-confirm-btn",
                  title: 'swal-title-change-password',
                },
                buttonsStyling: false,
            });
            swalFailedMessage.fire({
                title: "Reset Password Success",
                html: `<p class='swal-text-html'>We have successfully reset your password!
                        Click login to start using your new password.</p>`,
                imageWidth: 65,
                imageHeight: 60,
                confirmButtonText: "Login",
                reverseButtons: false,
                showCancelButton: false,
                allowOutsideClick: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    userLogOut();
                } 
            });
        } else {
          setLoading(false);
          const swalFailedMessage = Swal.mixin({
            customClass: {
                popup: 'swal-failed-popup',
                confirmButton: "swal-success",
                title: 'swal-title',
            },
            buttonsStyling: false,
          });
          swalFailedMessage.fire({
              title: "Sorry!",
              html: `<p class='swal-text-html'>${res.data.error_message}</p>`,
              imageWidth: 65,
              imageHeight: 60,
              confirmButtonText: "Ok",
          });
        }
    }

    const userLogOut = () => {
        const payload = {
            "user_uid": userInfo?.uid
        };
        dispatch(logoutUser(payload)).then((result) => {
            if(result.payload.status === 1) {
                // show error message when logout is failed
                const swalFailedMessage = Swal.mixin({
                    customClass: {
                        popup: 'swal-failed-popup',
                        confirmButton: "swal-success",
                        title: 'swal-title',
                    },
                    buttonsStyling: false,
                });
                swalFailedMessage.fire({
                    title: "Sorry!",
                    html: `<p class='swal-text-html'>${result.payload.error_message}</p>`,
                    imageWidth: 65,
                    imageHeight: 60,
                    confirmButtonText: "Ok",
                });
            
            } else {
                // if logout success redirect to login page
                navigate("/login");
            }
        });
    }

    // function to handling show or hide password
    const handlingShowPassword = () => {
        if(showPassword === true) {
        setShowPassword(false)
        } else {
        setShowPassword(true)
        }
    }

  return (
    <>
        <div className="">
            <Navbar />
            <div className="max-w-screen-lg mx-auto">
                <div className="pt-[50px] w-full">
                    <h1 className="font-gluten text-custom-navy font-bold text-4xl">
                        Password
                    </h1>
                    <div className="flex flex-row gap-10 mt-[40px] h-screen">
                        <Formik
                            initialValues= {initialValues}
                            validationSchema= {changePasswordSchema}
                            onSubmit={(values) => onHandleChangePassword(values)}
                        >
                            {({errors}) => {
                            return (
                                <Form>
                                    <div className="w-[1024px] grid grid-cols-2 gap-y-[50px] gap-x-[25px]">
                                        <div className="col-span-2">
                                            <p className="text-xl mb-2">Old Password*</p>
                                            <Field
                                                type="password"
                                                name="old_password"
                                                placeholder="Enter Old Password"
                                                className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                                            />
                                            {errors.old_password && <small className="text-red-500">{errors.old_password}</small>}
                                        </div>
                                        <div>
                                            <div className="flex justify-end items-center relative">
                                                <div className="w-full">
                                                    <p className="text-xl mb-2">New Password*</p>
                                                    <Field
                                                        type={showPassword === true ? 'text' : 'password'}
                                                        name="new_password"
                                                        placeholder="New Password"
                                                        className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                                                    />
                                                </div>

                                                <div className="w-[24px] h-[24px] absolute mr-6 mt-[35px] flex-shrink-0 cursor-pointer" onClick={handlingShowPassword}>
                                                    <img
                                                    src= {showPassword === true ? HidePassword : ShowPassword}
                                                    width={24}
                                                    height="auto"
                                                    />
                                                </div>
                                            </div> 

                                            {errors.new_password && <small className="text-red-500">{errors.new_password}</small>}
                                        </div>
                                        <div>
                                            <p className="text-xl mb-2">Confirm New Password*</p>
                                            <Field
                                            type={showPassword === true ? 'text' : 'password'}
                                            name="confirm_new_pasword"
                                            placeholder="Confirm Password"
                                            className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                                            />
                                            {errors.confirm_new_pasword && <small className="text-red-500">{errors.confirm_new_pasword}</small>}
                                        </div>
                                        <div className=" col-span-2 rounded-[67.491px] py-[20px] mt-[20px] bg-custom-navy text-white text-base font-bold text-center cursor-pointer">
                                            <button type="submit" className="w-full">Save Changes</button>
                                        </div>
                                    </div>
                                </Form>
                            )}}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
        {loading && <Loader />}
    </>

  );
}

export default ChangePassword;
